<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import sitesService from "@/services/sites.js";
import journeyService from "@/services/journey.js";

export default {
  name: "UpdateActionForm",
  data() {
    return {
      modal_id: null,
      getCountUsersSingnedIn: null,
      site: null,
      sitesWithJourney: [],
      showWarning: null,
      subWarningMessage: "",
      area: null,
      currentArea: null,
      areaId: null,
      areaOptions: [],
      loadingAreaOptions: null,
      submitted: false,
      update: false,
      action: null,
      sites: [],
      areas: [],
      journeysList: [],
      parentId: null,
      isSignedInUsers: false,
      isLoading: true,
      disableBtn: null,
      form: {
        area: "",
        site: "",
        journey: "",
      },
    };
  },
  validations: {
    form: {
      area: { required },
      journey: { required },
      site: { required },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  watch: {
    async "$v.form.site.$model"(site) {
      const areaHasKiosk = this.currentArea?.kiosksOnlyCount > 0;
      const areaHasSubAreas = this.currentArea?.children?.length > 0;

      //Note will only be displayed only if different site (other than current area's site) is selected
      //and current area has at least one kiosk or one subarea
      if (
        this.currentArea?.parentSite.id === site.id ||
        (!areaHasKiosk && !areaHasSubAreas)
      )
        this.showWarning = false;
      else if (this.currentArea?.parentSite.id !== site.id) {
        this.showWarning = true;
        if (areaHasKiosk && areaHasSubAreas)
          this.subWarningMessage = this.$t('sitesAndDevices.moveAreaJourneyAreasAndKiosks');
        else if (areaHasKiosk) this.subWarningMessage = this.$t('sitesAndDevices.moveAreaJourneyKiosks');
        else if (areaHasSubAreas) this.subWarningMessage =this.$t('sitesAndDevices.moveAreaJourneyAreas');
      }
      const { data } = await journeyService.getJourneysNormal(site.id);
      this.journeysList = data;
    },
  },
  methods: {
    async setAreaOptions() {
      this.loadingAreaOptions = true;
      const { data: areaOptions } =
        await sitesService.fetchAreasBySiteWithoutSignOut({
          area_id: this.currentArea.id,
          site_id: this.form.site.id,
        });

      this.areaOptions = areaOptions;
      this.areaOptions.push({ id: null, name: "Assigned as parent" });
      this.areaOptions = this.areaOptions.filter(
        (item) => item.id !== this.getModalInfo.id
      );
      this.loadingAreaOptions = false;
    },
    async siteHandler(site) {
      this.form.area = "";
      this.form.journey = "";

      await this.setAreaOptions();

      if (!this.currentArea.parent_id) {
        if (site.id == this.currentArea.site_id) {
          this.area = "";
          this.disableBtn = true;
        }
      } else {
        const parentArea = this.getAreas?.find(
          (parentArea) => parentArea.id == this.currentArea.parent_id
        );
        if (parentArea) {
          this.parentId = parentArea.id;
          this.form.area = parentArea;
        }
      }
    },
    updateDisableBtn() {
      if (
        !this.currentArea.parent_id &&
        !this.area &&
        this.site.id == this.currentArea.site_id
      ) {
        this.disableBtn = true;
      } else {
        if (this.parentId && this.parentId == this.area?.id) {
          this.disableBtn = true;
        } else {
          this.disableBtn = false;
        }
      }
    },
    onSubmit() {
      if (this.$v.form.$invalid) return;
      this.submitted = true;
      this.$emit(
        "moveArea",
        {
          id: this.areaId,
          params: {
            area: {
              site_id: this.form.site.id,
              parent_id: this.form.area?.id || null,
              journey_id: this.form.journey.id,
            },
          },
        },
        `moveArea_ ${this.modal_id}`
      );
    },
  },
  async beforeMount() {
    this.modal_id = this.getModalInfo.modalId;

    this.currentArea = this.getModalInfo;

    this.form.site = this.getModalInfo?.parentSite;

    if (!this.currentArea.parent_id) this.disableBtn = true;

    const { data: normalSites } = await sitesService.getNormalSites();
    const { data: entitySites } = await sitesService.getSites();

    const { id, site_id } = this.getModalInfo;
    this.areaId = id;

    //Set site
    this.site = entitySites?.find((site) => site.id == site_id);

    this.sitesWithJourney = normalSites?.filter(
      (site) => site.journeys_count > 0
    );

    const { data } = await sitesService.getCountUsersSingnedInApi(this.areaId);
    this.getCountUsersSingnedIn = data;

    const { data: areaOptions } =
      await sitesService.fetchAreasBySiteWithoutSignOut({
        area_id: this.currentArea.id,
        site_id: this.site.id,
      });

    this.areaOptions = areaOptions;
    this.areaOptions.push({ id: null, name: "Assigned as parent" });
    this.areaOptions = this.areaOptions.filter(
      (item) => item.id !== this.getModalInfo.id
    );

    if (this.currentArea.parent_id)
      this.form.area = areaOptions?.find(
        (area) => area.id == this.currentArea.parent_id
      );
    else this.form.area = { id: null, name: "Assigned as parent" };

    //Check if theres signed in users in area
    if (
      this.getCountUsersSingnedIn &&
      this.currentArea.loginMode == "signIn_signOut"
    )
      this.isSignedInUsers = true;

    //Set journey
    this.form.journey = this.journeysList?.find(
      (journey) => journey.id == this.getModalInfo?.journey_id
    );
    this.isLoading = false;
  },
};
</script>

<template>
  <vpFormModal :id="modal_id + 'FormModal'" :showCloseIcon="false">
    <template v-slot:header>
      <span>{{ $t("sitesAndDevices.areaActions.moveArea")}}</span>
    </template>

    <template v-slot:content>
      <!-- site  -->
      <b-form-group>
        <vp-multiselect
          id="site"
          v-model="$v.form.site.$model"
          :options="sitesWithJourney"
          :title="$t('common.site')"
          :showLabel="false"
          label="name"
          :allowEmpty="false"
          :disabled="isSignedInUsers || submitted"
          :showPlaceholderIcon="true"
          @deselect="siteHandler"
          @select="siteHandler"
          dropDownStyle="relative"
          zIndex="4"
        />
      </b-form-group>
      <!-- area  -->
      <b-form-group>
        <vp-multiselect
          id="area"
          v-model="$v.form.area.$model"
          :title="$t('common.area')"
          :options="areaOptions"
          placeholder="Parent Area"
          :showLabels="false"
          label="name"
          dropDownStyle="relative"
          :allowEmpty="true"
          :showPlaceholderIcon="true"
          :disabled="
            !site || isSignedInUsers || submitted || loadingAreaOptions
          "
          :isLoading="loadingAreaOptions"
          zIndex="3"
          @input="updateDisableBtn()"
        />
      </b-form-group>
      <p v-if="isSignedInUsers" class="notes">
        <b>{{ $t("common.notes.note")}}: </b>{{ $t("sitesAndDevices.moveAreaWaning_2")}}
      </p>
      <!-- Journey -->
      <b-form-group>
        <vp-multiselect
          id="jourey"
          dropDownStyle="relative"
          v-model="$v.form.journey.$model"
          :title="$t('common.journey')"
          :options="journeysList"
          placeholder="Journey"
          :show-labels="false"
          label="name"
          :allowEmpty="true"
          :showPlaceholderIcon="true"
          :disabled="!site || isSignedInUsers || submitted"
          zIndex="2"
        />
        <p v-if="showWarning" class="notes vp-mt-8">
          <b>{{ $t('common.notes.note')}}: </b>{{ subWarningMessage }}
        </p>
      </b-form-group>
    </template>

    <template v-slot:footer>
      <VpButton :text="$t('common.move')" :disabled="
          submitted || isSignedInUsers || $v.form.$invalid || !$v.form.$anyDirty
        " :isLoading="submitted" @click="onSubmit"/>

        <VpButton :text="$t('common.cancel')" :disabled="submitted"
        :class="{ 'cursor-stop': submitted }" :isLoading="submitted" @click="$bvModal.hide(modal_id)" :isDanger="true"/>
    </template>
  </vpFormModal>
</template>
